import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
import Logo from 'components/ui-component/Logo';
import { MENU_OPEN } from 'utils/actions';
import { useMenu } from 'context/menu-context';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
	const { state: customization, dispatch } = useMenu();
	const defaultId = customization.defaultId;
	return (
		<ButtonBase disableRipple onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} component={Link} to={config.defaultPath}>
			<Logo />
		</ButtonBase>
	);
};

export default LogoSection;
